import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SiteLogin } from "../../Api/Services";
import InputCus from "../../Component/InputCus/Text/InputCus";

function LoginSite() {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  let { StoreId } = useParams();

  const HamdelLogin = async () => {
    setLoading(true);
    const SiteLoginData = await SiteLogin({
      username: username,
      password: password,
      StoreId: StoreId,
    });
    if (SiteLoginData.status && SiteLoginData.status === 200) {
      navigate("/Panel/Site");
    }
    setLoading(false);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="username"
              id="username"
              text="username"
              className="m-2"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
            <InputCus
              type="text"
              name="password"
              id="password"
              text="password"
              className="m-2"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={HamdelLogin} className="btnSearch">
              ورود
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginSite;
